import { makeAutoObservable } from 'mobx';
import { TabIds } from '~/definitions/tab';
import getTabs from './fn/getTabs';
import onTabChange from './fn/onTabChange';
import fetchTabData from './fn/fetchTabData';

export default class TabStore {
    activeTabId: TabIds = '';
    changedTabId: TabIds = '';
    isMenuOpened: boolean = false;
    isTabContentReset: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.activeTabId = '';
        this.changedTabId = '';
        this.isMenuOpened = false;
        this.isTabContentReset = false;
    }

    setActiveTabId = (value: TabIds): void => {
        this.activeTabId = value;
    };

    setChangedTabId = (value: TabIds): void => {
        this.changedTabId = value;
    };

    setIsMenuOpened = (isOpened: boolean) => {
        this.isMenuOpened = isOpened;
    };

    setIsTabContentReset = (isReset: boolean) => {
        this.isTabContentReset = isReset;
    };

    getTabs = getTabs;
    onTabChange = onTabChange;
    fetchTabData = fetchTabData;
}
